import jQuery from 'jquery';

// Set jQuery and $ on window - some 3rd party libraries need it.
window.jQuery = jQuery;
window.$ = jQuery;

export {};
